import { render } from "./EventList.vue?vue&type=template&id=f27bae20&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=f27bae20&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue practice\\vue mastery\\real world vue 3\\7. Deploying with Render\\deploying-with-render\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27bae20"]])

export default __exports__